import { useState } from 'react';

export default (currentPageSize = 10) => {
  const [pageSize, setPageSize] = useState<number>(currentPageSize);
  const [page, setPage] = useState<number>(1);

  const handlePageSizeChange = (value: number) => setPageSize(value);
  const handlePageChange = (value: number) => setPage(value);

  return {
    pageSize,
    page,
    handlePageSizeChange,
    handlePageChange,
  };
};
